import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { CallDetail, EventDetail } from '../contacts/shared/models/Contact';
import { parsePhoneNumberFromString, format } from 'libphonenumber-js';
import { formatRecordingFileName } from '../shared/utils/file-utils';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {
  public onSetEventId = new BehaviorSubject<number>(opener);
  constructor(private http: HttpClient) {}

  getEventDetails(eventId): Observable<EventDetail> {
    return this.http.get<EventDetail>(`/contacts/events/${eventId}`);
  }

  setEventId(id: number) {
    this.onSetEventId.next(id);
  }

  getCallDetails(eventId): Observable<CallDetail> {
    return this.http.get<CallDetail>(`/calls/${eventId}`);
  }

  createVoicemailFilename(event) {
    const currentEvent = {
      ...event,
      name: event.name || event.agentName,
      surname: event.surname || event.agentSurname,
      createdAt: event.createdAt || event.startDate
    };

    return (
      `${currentEvent.name ? currentEvent.name : currentEvent.id}
    _${currentEvent.surname ? currentEvent.surname : ''}` + formatRecordingFileName(currentEvent)
    );
  }

  getRecordingUrl(eventId: number) {
    return `/calls/${eventId}/recording`;
  }

  getFormatedNumber(number: string) {
    if (number.startsWith('webcall')) {
      return number;
    }
    const generalNumber = parsePhoneNumberFromString(number.toString());
    return format(generalNumber.number, generalNumber.country, 'INTERNATIONAL');
  }
}
